<template>
	<div class="title-list-options">
		<div class="title-list-options__box">
			<div class="title-list-options__box-left">
				<TitlesCountSeo :amount="amount" />
				<TitleListSortingSwitcherSeo v-if="showSortingSwitcher" :collectionType="collectionType" />
			</div>

			<div class="title-list-options__box-right">
				<div v-show="collectionType === CollectionType.TITLELIST" class="title-list-options__box-btns">
					<FilterButtonSeo :collectionType="collectionType" />
					<ResetButton />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import ResetButton from '@/components/buttons/ResetButton.vue';
import TitlesCountSeo from '@/components/filter-bar/seo/TitlesCountSeo.vue';
import FilterButtonSeo from '@/components/filter-bar/seo/FilterButtonSeo.vue';
import TitleListSortingSwitcherSeo from '@/components/filter-bar/seo/TitleListSortingSwitcherSeo.vue';
import { CollectionType } from '@/enums/collection-type';

interface TitleListOptionsSeoProps {
	amount?: number;
	showSortingSwitcher?: boolean;
	collectionType: CollectionType;
}

withDefaults(defineProps<TitleListOptionsSeoProps>(), {
	amount: 0,
	showSortingSwitcher: true,
});
</script>

<style scoped lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.title-list-options {
	position: relative;
	min-height: 36px;
	white-space: nowrap;
	width: 100%;

	@media (max-width: $breakpoint-two-rows) {
		padding: 0 15px 0;
	}

	&__box {
		display: flex;
		width: 100%;

		@media (max-width: $screen-xs) {
			flex-direction: column;
			align-items: start;
			align-items: stretch;
		}

		@media (min-width: $screen-xs) {
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}

		&-left {
			display: flex;
			align-items: center;
			max-width: 70vw;
		}

		&-right {
			display: flex;
			align-items: center;
			color: var(--jw-color-secondary) !important;
			text-align: end;
		}

		&-view {
			display: none;
			@media (min-width: $screen-md) {
				display: block;
			}
		}

		&-btns {
			display: flex;
			align-items: center;
			margin-inline-start: 16px;

			.button {
				&:last-child {
					--padding-end: 0;
				}
			}
		}
	}
}
</style>
